<template>
  <d-card class="card-small">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Lista de tipos de {{ label }}</h6>
    </d-card-header>

    <d-card-body class="p-0 pb-1">
      <d-list-group>
        <d-list-group-item
          v-for="(row, index) in list"
          :key="index"
          class="d-flex px-3"
        >
          <span class="text-semibold text-fiord-blue col pl-0">
            <d-input
              v-model="row.name"
              class="input-hidden"
              :placeholder="label"
              @change="onChange(index, row)"
            />
          </span>
          <span class="ml-auto text-right text-semibold col-auto px-0">
            <i
              class="fas fa-plus"
              @click="onAdd()"
              v-if="index + 1 === list.length"
            />
            <i
              class="fas fa-minus"
              @click="onRemove(index)"
              v-if="list.length > 1"
            />
            <i
              class="fas fa-save"
              @click="onSave(index, row)"
              v-if="showSave"
            />
          </span>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
  </d-card>
</template>

<script>
export default {
  name: 'DynamicList',
  props: {
    list: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: 'Item',
    },
    showSave: {
      type: Boolean,
      default: false,
    },
    onAdd: {
      type: Function,
      default: () => {},
    },
    onRemove: {
      type: Function,
      default: () => {},
    },
    onSave: {
      type: Function,
      default: () => {},
    },
    onChange: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~_scss/overrides";

.card .list-group-item {
    border-radius: 0;
}

.input-hidden {
  width: 100%;
  border: 0;
  padding: 0;
  color: #3D5170;
  font-weight: 400;
  font-size: 15px;
  &:focus {
    box-shadow: none;
    border: 0;
  }
}

.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red
  }
  &.fa-save:hover{
    color: $blue;
  }
}
</style>
